/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

//aタグ スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;

    const $hd = $('.l-header');
    if($hd[0]) {
      position -= $hd.innerHeight();
    }
    
    $("html, body").animate({scrollTop:position}, speed, "swing");

    //SPメニュー閉じる
    const $menu = $('.p-hd__menuSP');
    const $nav = $('.p-hd__navWrap');
    $menu.removeClass('is-on');
    $nav.removeClass('is-open');

    return false;
  });
});

$(function(){
  const $lBody = $('.l-body.-home');

  if($lBody[0]) {
    const $html = $('html');
    const $anime = $('.home-kv__anime');
    let hash = location.hash;

    if(hash) {
      $lBody.addClass('is-show');
      $lBody.addClass('is-intro');
      $lBody.addClass('is-intro2');
      $lBody.addClass('is-introEnd');

      setTimeout(function(){
        var target = $(hash);
        var position = target.offset().top;
        $('body,html').stop().animate({scrollTop:position}, 0);
      }, 200);
    } else {
      $('html,body').animate({ scrollTop: 0 }, '1');

      $html.css({
        overflow: 'hidden'
      })

      $lBody.addClass('is-show');

      setTimeout(function(){
        let animeH = $anime.innerHeight();
        let animeT = $anime.offset().top;
        let winH = $(window).innerHeight();
        
        if($('.u-pc').css('display') != 'none') {
          winH *= 1.2;
        }
        
        let y = (winH - animeH) / 2 - animeT;

        // $anime.css({
        //   marginTop: y + 'px'
        // })
        
        setTimeout(function(){
          $lBody.addClass('is-intro');

          setTimeout(function(){
            $lBody.addClass('is-intro2');
            $anime.removeAttr('style');
          }, 4200);
          
          setTimeout(function(){
            $lBody.addClass('is-introEnd');
            $html.removeAttr('style');
          }, 5600);
        }, 10);
      }, 400);
    }
  }
});

$(function(){
  const $hd = $('.l-header');

  if($hd[0]) {
    const $kv = $('.home-kv');

    let showPoint = 50;

    if($kv[0]) {
      showPoint = $kv.innerHeight() - $hd.innerHeight();
    }

    $(window).on('scroll', function () {
      run();
    });

    run();
    
    function run() {
      if($(window).scrollTop() > showPoint) {
        $hd.addClass('is-sc');
      } else {
        $hd.removeClass('is-sc');
      }
    }
  }
});

$(function(){
  const $menu = $('.p-hd__menuSP');

  if($menu[0]) {
    const $nav = $('.p-hd__navWrap');

    $menu.on('click', function () {
      $menu.toggleClass('is-on');
      $nav.toggleClass('is-open');
    });
  }
});

$(function(){
  $('.p-modalSlider__slick').each(function(index, el) {
    const $slider = $(this);
    const $numBtn = $('.js-modalSliderBtn[data-remodal-target="' + $slider.attr('data-slider-id') + '"]');

    $slider.slick({
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: true,
      dots: true
    });

    $numBtn.on('click', function () {
      let next = parseInt($(this).attr('data-remodal-num')) - 1;

      if(!isNaN(next)) {
        setTimeout(function(){
          $slider.slick('slickGoTo', next, true);
        }, 10);
      }
    });

    $(document).on('opening', '.remodal', function () {
      $slider.slick('setPosition');
    });
    
    $(document).on('opened', '.remodal', function () {
    });
    
    $(document).on('closing', '.remodal', function (e) {
    });
    
    $(document).on('closed', '.remodal', function (e) {
    });
  });
});

//fade in
const fade_in = $('.fade-in, .fade-ani');
if (fade_in.length > 0) {
  $(window).on('scroll load ready', function () {
    fade_in.each(function () {
      let offset = $(this).offset().top;
      let scroll = $(window).scrollTop();
      let windowHeight = $(window).height();
      if (scroll > offset - windowHeight + 150) {
        $(this).addClass('is-fade');
      }
    });
  });
}
